import { ScopeKey } from '../edit-session/ScopeKey';

export const SampleKey = {
  create: (type: string, id: number, valueDate: string) =>
    ScopeKey.join(type, id, valueDate),
};
